var CNAEActions;
(function (CNAEActions) {
    CNAEActions["DELETE_CNAE"] = "DeleteCNAE";
    CNAEActions["DELETE_RANGE_CNAE"] = "DeleteRangeCNAE";
    CNAEActions["FILTER_CNAE"] = "FilterCNAE";
    CNAEActions["GET_CNAE"] = "GetCNAE";
    CNAEActions["GETWITHDISABLED_CNAE"] = "GetWithDisabledCNAE";
    CNAEActions["GET_BY_ID_CNAE"] = "GetByIdCNAE";
    CNAEActions["POST_CNAE"] = "PostCNAE";
    CNAEActions["PUT_CNAE"] = "PutCNAE";
})(CNAEActions || (CNAEActions = {}));
var Formas_de_PagamentoActions;
(function (Formas_de_PagamentoActions) {
    Formas_de_PagamentoActions["DELETE_FORMAS_DE_PAGAMENTO"] = "DeleteFormas_de_Pagamento";
    Formas_de_PagamentoActions["DELETE_RANGE_FORMAS_DE_PAGAMENTO"] = "DeleteRangeFormas_de_Pagamento";
    Formas_de_PagamentoActions["FILTER_FORMAS_DE_PAGAMENTO"] = "FilterFormas_de_Pagamento";
    Formas_de_PagamentoActions["GET_FORMAS_DE_PAGAMENTO"] = "GetFormas_de_Pagamento";
    Formas_de_PagamentoActions["GETWITHDISABLED_FORMAS_DE_PAGAMENTO"] = "GetWithDisabledFormas_de_Pagamento";
    Formas_de_PagamentoActions["GET_BY_ID_FORMAS_DE_PAGAMENTO"] = "GetByIdFormas_de_Pagamento";
    Formas_de_PagamentoActions["POST_FORMAS_DE_PAGAMENTO"] = "PostFormas_de_Pagamento";
    Formas_de_PagamentoActions["PUT_FORMAS_DE_PAGAMENTO"] = "PutFormas_de_Pagamento";
})(Formas_de_PagamentoActions || (Formas_de_PagamentoActions = {}));
var CalendarioActions;
(function (CalendarioActions) {
    CalendarioActions["DELETE_CALENDARIO"] = "DeleteCalendario";
    CalendarioActions["DELETE_RANGE_CALENDARIO"] = "DeleteRangeCalendario";
    CalendarioActions["FILTER_CALENDARIO"] = "FilterCalendario";
    CalendarioActions["GET_CALENDARIO"] = "GetCalendario";
    CalendarioActions["GETWITHDISABLED_CALENDARIO"] = "GetWithDisabledCalendario";
    CalendarioActions["GET_BY_ID_CALENDARIO"] = "GetByIdCalendario";
    CalendarioActions["POST_CALENDARIO"] = "PostCalendario";
    CalendarioActions["PUT_CALENDARIO"] = "PutCalendario";
})(CalendarioActions || (CalendarioActions = {}));
var MaterialActions;
(function (MaterialActions) {
    MaterialActions["DELETE_MATERIAL"] = "DeleteMaterial";
    MaterialActions["DELETE_RANGE_MATERIAL"] = "DeleteRangeMaterial";
    MaterialActions["FILTER_MATERIAL"] = "FilterMaterial";
    MaterialActions["GET_MATERIAL"] = "GetMaterial";
    MaterialActions["GETWITHDISABLED_MATERIAL"] = "GetWithDisabledMaterial";
    MaterialActions["GET_BY_ID_MATERIAL"] = "GetByIdMaterial";
    MaterialActions["POST_MATERIAL"] = "PostMaterial";
    MaterialActions["PUT_MATERIAL"] = "PutMaterial";
    MaterialActions["POSTBACK_MATERIAL"] = "PostBackMaterial";
})(MaterialActions || (MaterialActions = {}));
var Status_MaterialActions;
(function (Status_MaterialActions) {
    Status_MaterialActions["DELETE_STATUS_MATERIAL"] = "DeleteStatus_Material";
    Status_MaterialActions["DELETE_RANGE_STATUS_MATERIAL"] = "DeleteRangeStatus_Material";
    Status_MaterialActions["FILTER_STATUS_MATERIAL"] = "FilterStatus_Material";
    Status_MaterialActions["GET_STATUS_MATERIAL"] = "GetStatus_Material";
    Status_MaterialActions["GETWITHDISABLED_STATUS_MATERIAL"] = "GetWithDisabledStatus_Material";
    Status_MaterialActions["GET_BY_ID_STATUS_MATERIAL"] = "GetByIdStatus_Material";
    Status_MaterialActions["POST_STATUS_MATERIAL"] = "PostStatus_Material";
    Status_MaterialActions["PUT_STATUS_MATERIAL"] = "PutStatus_Material";
})(Status_MaterialActions || (Status_MaterialActions = {}));
var Tipo_MaterialActions;
(function (Tipo_MaterialActions) {
    Tipo_MaterialActions["DELETE_TIPO_MATERIAL"] = "DeleteTipo_Material";
    Tipo_MaterialActions["DELETE_RANGE_TIPO_MATERIAL"] = "DeleteRangeTipo_Material";
    Tipo_MaterialActions["FILTER_TIPO_MATERIAL"] = "FilterTipo_Material";
    Tipo_MaterialActions["GET_TIPO_MATERIAL"] = "GetTipo_Material";
    Tipo_MaterialActions["GETWITHDISABLED_TIPO_MATERIAL"] = "GetWithDisabledTipo_Material";
    Tipo_MaterialActions["GET_BY_ID_TIPO_MATERIAL"] = "GetByIdTipo_Material";
    Tipo_MaterialActions["POST_TIPO_MATERIAL"] = "PostTipo_Material";
    Tipo_MaterialActions["POSTBACK_TIPO_MATERIAL"] = "PostBackTipo_Material";
    Tipo_MaterialActions["PUT_TIPO_MATERIAL"] = "PutTipo_Material";
})(Tipo_MaterialActions || (Tipo_MaterialActions = {}));
var MoedaActions;
(function (MoedaActions) {
    MoedaActions["DELETE_MOEDA"] = "DeleteMoeda";
    MoedaActions["DELETE_RANGE_MOEDA"] = "DeleteRangeMoeda";
    MoedaActions["FILTER_MOEDA"] = "FilterMoeda";
    MoedaActions["GET_MOEDA"] = "GetMoeda";
    MoedaActions["GETWITHDISABLED_MOEDA"] = "GetWithDisabledMoeda";
    MoedaActions["GET_BY_ID_MOEDA"] = "GetByIdMoeda";
    MoedaActions["POST_MOEDA"] = "PostMoeda";
    MoedaActions["PUT_MOEDA"] = "PutMoeda";
})(MoedaActions || (MoedaActions = {}));
var Time_ColaboradorActions;
(function (Time_ColaboradorActions) {
    Time_ColaboradorActions["DELETE_TIME_COLABORADOR"] = "DeleteTime_Colaborador";
    Time_ColaboradorActions["DELETE_RANGE_TIME_COLABORADOR"] = "DeleteRangeTime_Colaborador";
    Time_ColaboradorActions["FILTER_TIME_COLABORADOR"] = "FilterTime_Colaborador";
    Time_ColaboradorActions["GET_TIME_COLABORADOR"] = "GetTime_Colaborador";
    Time_ColaboradorActions["GETWITHDISABLED_TIME_COLABORADOR"] = "GetWithDisabledTime_Colaborador";
    Time_ColaboradorActions["GET_BY_ID_TIME_COLABORADOR"] = "GetByIdTime_Colaborador";
    Time_ColaboradorActions["POST_TIME_COLABORADOR"] = "PostTime_Colaborador";
    Time_ColaboradorActions["PUT_TIME_COLABORADOR"] = "PutTime_Colaborador";
})(Time_ColaboradorActions || (Time_ColaboradorActions = {}));
var SituacaoActions;
(function (SituacaoActions) {
    SituacaoActions["DELETE_SITUACAO"] = "DeleteSituacao";
    SituacaoActions["DELETE_RANGE_SITUACAO"] = "DeleteRangeSituacao";
    SituacaoActions["FILTER_SITUACAO"] = "FilterSituacao";
    SituacaoActions["GET_SITUACAO"] = "GetSituacao";
    SituacaoActions["GETWITHDISABLED_SITUACAO"] = "GetWithDisabledSituacao";
    SituacaoActions["GET_BY_ID_SITUACAO"] = "GetByIdSituacao";
    SituacaoActions["POST_SITUACAO"] = "PostSituacao";
    SituacaoActions["PUT_SITUACAO"] = "PutSituacao";
})(SituacaoActions || (SituacaoActions = {}));
export { CNAEActions, Formas_de_PagamentoActions, CalendarioActions, MaterialActions, Status_MaterialActions, Tipo_MaterialActions, MoedaActions, Time_ColaboradorActions, SituacaoActions };
//# sourceMappingURL=CadEnums.js.map